import { post, get, put, del as requestDel } from '@/utils/request';

// 新增/修改设备分类
export function EquipmentClassificationAdd(Data) {
  if (Data.id && Data.id > 0) {
    return put('/api/v1/equipment-classification/' + Data.id, Data);
  }
  return post('/api/v1/equipment-classification', Data); 
}

// 设备分类列表
export function EquipmentClassificationList(Data) {
  return get('/api/v1/equipment-classification/page', Data); 
}

// 设备分类删除
export function EquipmentClassificationDel(Data) {
  const id = typeof Data === 'object' ? Data.id : Data;
  return requestDel('/api/v1/equipment-classification/' + id); 
}

// 设备分类下拉列表
export function EquipmentClassificationSelectList() {
  return get('/api/v1/equipment-classification/list'); 
}

// 设备分类详情
export function EquipmentClassificationDetail(Data) {
  const id = typeof Data === 'object' ? Data.id : Data;
  return get('/api/v1/equipment-classification/detail', { id }); 
}
